import Vue from 'vue'
import App from './App.vue'


import PrismicVue from 'prismic-vue';
window.prismic = {
	endpoint: 'https://test-repo-nt.cdn.prismic.io/api/v2'
};	

// function linkResolver	(doc) {
//   // Return the path depending on Prismic Document's type
//   // If it is a Single Custom Type with the API ID of "home"
//   if (doc.type === 'home') {
//     return '/';
//   }
//   // If it is a Repeatable Custom Type with the API ID of "page" (must contain a UID field)
//   if (doc.type === 'page') {
//     return '/page/' + doc.uid;
//   }
 
//   // Default to the root
//   return '/';
// };


// Add this before the new Vue instance
Vue.use(PrismicVue, {
  endpoint: window.prismic.endpoint,
  // linkResolver
});


new Vue({
  render: h => h(App),
}).$mount('#app')
